import { render } from "./InlineButton.vue?vue&type=template&id=1afeeb43"
import script from "./InlineButton.vue?vue&type=script&lang=js"
export * from "./InlineButton.vue?vue&type=script&lang=js"

import "./InlineButton.vue?vue&type=style&index=0&id=1afeeb43&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__